const privacyNotice = {
  title: {
    textStyle: 'body.smallPrint.regular',
    color: 'neutrals.4',
    pl: 3
  },
  subheading: {
    textStyle: 'body.smallPrint.regular',
    color: 'neutrals.3'
  }
}

export default privacyNotice
